import { render, staticRenderFns } from "./ActionCenterEmpty.vue?vue&type=template&id=5661658e&scoped=true"
import script from "./ActionCenterEmpty.vue?vue&type=script&lang=js"
export * from "./ActionCenterEmpty.vue?vue&type=script&lang=js"
import style0 from "./ActionCenterEmpty.vue?vue&type=style&index=0&id=5661658e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5661658e",
  null
  
)

export default component.exports